import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { ApiErrorResponse, ErrorTypeEnum, WrongKioskErrorMetadata } from 'types/Error';
import { ContextResponse } from 'modules/dealers/types/ContextResponse';
import type {
  LoginResponse,
  MFAAttemptsDetails,
  SendMFACodeResponse,
  WhatsAppDetails,
} from 'modules/auth/types/LoginResponse';
import type { PhoneNumber } from 'modules/selfServices/types/SelfService';
import { ChannelEnum } from './LoginRequest';

export const LOCAL_STORAGE_KEY = 'cookies.setting';

export enum CookiesSettings {
  ESSENTIAL = 'essential',
  ANALYTICS = 'analytics',
}

export type MFA = ContextResponse & MFAAttemptsDetails & SendMFACodeResponse & {
  email: string;
  phoneNumber: string;
  connectionId: string;
  vehicleCheckEnabled: boolean;
  interventionLastMessageChannel: ChannelEnum;
  whatsApp: WhatsAppDetails;
};

export interface LoginData {
  qrCode?: string,
  codeInputDisabled?: boolean,
  registration? : string,
  phoneNumber?: PhoneNumber,
  locationId?: number,
  dealerId?: string,
  brandId?: string,
  isDriver?: boolean,
}

type LoginRequestState = {
  isLoading: boolean;
  data: LoginData;
  error: ApiErrorResponse | FetchBaseQueryError | SerializedError;
};

export enum ScheduleTypeEnum {
  LOGOUT = 'LOGOUT',
  DOORS = 'DOORS',
}

export type Schedule = Partial<Record<ScheduleTypeEnum, string>>;
export type MFAError = { type: ErrorTypeEnum } & WrongKioskErrorMetadata;

export type CodeLoginError = {
  remainingCode: number;
  retryExpiration?: string;
};

export type InitialState = LoginResponse & {
  schedule?: Schedule;
  login?: LoginRequestState;
  selfServiceId?: string;
  publicToken?: string;
  dealerId?: string;
  mfa?: MFA;
  qrCode?: string;
  mfaError?: MFAError;
  codeLoginError?: CodeLoginError;
  qrCodeToken?: string;
  adminToken?: string;
  adminCodeAttempt?: number;
  vehicleCheckPublicToken?: string;
  kioskRootAccess?: boolean;
  cookies?: CookiesSettings[];
  notFound?: boolean;
};
